import styled from '@emotion/styled';

const TabContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing[70]};
  grid-column: span 12 / span 12;
`;

export { TabContainer };
